import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppData } from '../AppData';
import { UserRightsFunctionModel } from '../../models/rights/user-rights-function/user-rights-function.model';
import { Observable } from 'rxjs/internal/Observable';
import { UrlBuilder } from '../../models/frontend_entities/UrlBuilder';
import Constants from '../../Constants';
import { take } from 'rxjs/operators';
import {
  UserRightsRoleToUserRightsFunctionDTO
} from '../../models/rights/user-rights-role/UserRightsRoleToUserRightsFunctionDTO';

@Injectable()
export class UserRightsFunctionRequestService {

  //region CONSTRUCTOR
  constructor(
    private http: HttpClient,
    private data: AppData
  ) {
  }
  //endregion

  //region GET
  getById(userRightsFunctionId: string): Observable<UserRightsFunctionModel> {
    const url = new UrlBuilder(Constants.URLS.userRightsFunction.getById)
      .param('id', userRightsFunctionId)
      .param('lang', this.data.getLang())
      .build();

    return this.http.get<UserRightsFunctionModel>(url).pipe(take(1));
  }
  //endregion

  //region CREATE
  save(dto: UserRightsFunctionModel): Observable<UserRightsFunctionModel> {
    const url = new UrlBuilder(Constants.URLS.userRightsFunction.base)
      .param('lang', this.data.getLang())
      .build();
    return this.http.post<UserRightsFunctionModel>(url, dto).pipe(take(1));
  }
  //endregion

  //region UPDATE
  updateRx(dto: UserRightsFunctionModel): Observable<UserRightsFunctionModel> {
    const url = new UrlBuilder(Constants.URLS.userRightsFunction.base)
      .param('lang', this.data.getLang())
      .build();
    return this.http.put<UserRightsFunctionModel>(url, dto).pipe(take(1));
  }
  //endregion

  //region DELETE
  deleteRx(id: string): Observable<void | Object> {
    const url = new UrlBuilder(Constants.URLS.userRightsFunction.base)
      .param('id', id)
      .build();

    return this.http.delete(url).pipe(take(1));
  }
  //endregion

  //region MAPPING USER ROLE TO USER FUNCTION
  addUserRightsFunctionToUserRightsRole(userRightsFunctions: UserRightsRoleToUserRightsFunctionDTO) : Observable<any>{
    const url = new UrlBuilder(Constants.URLS.userRightsFunction.addUserRightsFunctionToUserRightsRole)
      .build();

    return this.http.post(url, userRightsFunctions).pipe(take(1));
  }

  removeUserRightsFunctionFromUserRightsRole(userRightsFunctions: UserRightsRoleToUserRightsFunctionDTO) : Observable<any>{
    const url = new UrlBuilder(Constants.URLS.userRightsFunction.removeUserRightsFunctionFromUserRightsRole)
      .build();

    return this.http.post(url, userRightsFunctions).pipe(take(1));
  }
  //endregion
}
